import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import {
	ICreateCampaignRequest,
	ICreateSocialMediaPostRequest,
	ILocationState,
	TemplateOrTemplateFilter,
} from '../../../models';
import { CampaignType } from '../../../models/AdminModels';
import { BlogPostRequest } from '../../../models/Blogs';
import { useFullscreenModal, useUserSession } from '../../../models/hooks/appStateHooks';
import { ContentCalendarTemplateBrowser } from './ContentCalendarTemplateBrowser';
import { styleSheet } from './styles';

type Props = {
	templateBrowserCampaignType: CampaignType;
	setTemplateBrowserCampaignType: (campaignType: CampaignType) => void;
	isSuggestionsOn?: boolean;
};

export const ContentCalendarTemplateBrowserWrapper: React.FC<Props> = ({
	templateBrowserCampaignType,
	setTemplateBrowserCampaignType,
	isSuggestionsOn,
}) => {
	const fullscreenModal = useFullscreenModal();
	const userSession = useUserSession();

	const droppableType = 'campaignTemplateCard';
	const campaignTypes = [CampaignType.Email, CampaignType.Social, CampaignType.Blog].filter(Boolean);

	const handleCampaignTemplateClicked = (
		template: Api.ITemplate,
		schedule?: Api.IScheduledSend,
		_referrer = 'contentCalendarAppDrawer'
	) => {
		if (template?.templateType === Api.TemplateType.Email || !template?.templateType) {
			const locationStateEmail: ILocationState<any, ICreateCampaignRequest<TemplateOrTemplateFilter>> = {
				model: {
					context: template,
					onFinish: (_didSend: boolean) => {
						// Email campaign finished
					},
					schedule,
					type: 'Template',
				},
			};
			fullscreenModal?.history.push({
				pathname: '/email/campaigns/create/from-template',
				state: locationStateEmail,
			});
		} else if (template.templateType === Api.TemplateType.Blog) {
			const locationState: ILocationState<any, BlogPostRequest> = {
				model: {
					schedule,
					template,
				},
			};
			fullscreenModal?.history.push({
				pathname: `/blog/post/create-from-template/${template.id}`,
				state: locationState,
			});
		} else if (template.templateType === Api.TemplateType.SocialMediaPost) {
			const locationStateSocial: ILocationState<any, ICreateSocialMediaPostRequest<Api.ITemplate>> = {
				model: {
					context: template,
					onFinish: (_didSend: boolean) => {
						// Social campaign finished
					},
					schedule,
					sendFromUser: userSession.user,
					type: 'Template',
				},
			};
			fullscreenModal?.history.push({
				pathname: `/social-media/post/create/from-template`,
				state: locationStateSocial,
			});
		}
	};

	return (
		<div className={css(styleSheet.appDrawerTemplateBrowserContainer)}>
			<ContentCalendarTemplateBrowser
				isAppDrawer={true}
				dragDropProps={{
					droppableId: 'campaignTemplatesList',
					type: droppableType,
					draggingStyles: [styleSheet.campaignTemplateCardDragging],
				}}
				onTemplateTypeSelected={setTemplateBrowserCampaignType}
				onCampaignTemplateClicked={handleCampaignTemplateClicked}
				selectedCampaignType={templateBrowserCampaignType}
				campaignTypes={campaignTypes}
				isSuggestionsOn={isSuggestionsOn}
			/>
		</div>
	);
};
